import { jsx } from "react/jsx-runtime";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import { validateTidalLicense } from "../../base/index.js";
function CallOutlined(props) {
  return /* @__PURE__ */ jsx(
    CallOutlinedIcon,
    {
      "data-testid": "CallOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CallOutlined",
      "data-tidal-icon-meta": "mail,contact,calendar"
    }
  );
}
CallOutlined.tidalIconMeta = {
  categories: "mail,contact,calendar",
  name: "CallOutlined"
};
validateTidalLicense();
export {
  CallOutlined
};
//# sourceMappingURL=CallOutlined.js.map
